<template>
  <div
    class="decorative-panel"
    :style="{ backgroundColor: appOptions.themeColor }" />
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "DecorativePanel",
  computed: { ...mapState({ appOptions: state => state.appOptions }) },
}
</script>

<style lang="scss" scoped>
.decorative-panel {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  transform: rotate(2deg);
  box-shadow: rgba(0, 0, 0, 0.16) 4px 4px 4px;
  z-index: -1;
  top: 0;
  left: 0;
  -webkit-animation: soft-spin 4s;
  -moz-animation: soft-spin 4s;
  animation: soft-spin 4s;
  background-color: color(mandarineOrange);
}
</style>
